<div *ngIf="showLoanUnits" class="mt-3 mb-3" [formGroup]="group">

    <div class="d-flex pb-2 mb-md-0">
        <div class="flex-grow-1">
            <div class="back-and-title">
                <h4 translate="Job.LoanUnit"></h4>
            </div>
        </div>
        <div class="ml-2">
            <div *ngIf="group.enabled" class="btn-group">
                <!-- form-djm-->
                <button
                    class="btn btn-primary"
                    [disabled]="
                        !unPrintedLines() ||
                        group.invalid ||
                        !canPrint
                    "
                    (click)="newDeliveryNote()"
                    title="Create new document"
                    data-cy="loan-unit-create-new-document"
                >
                    <i class="fa fa-print"></i>
                </button>
                <button
                    class="btn btn-primary"
                    *ngIf="(!externaLoanUnits && canAddLine) && addLineOptions.includes('SINGLE')"
                    (click)="newMovement('', '')"
                    data-cy="loan-unit-add-new-line"
                >
                    <i class="fa fa-plus" title="Add new line"></i>
                </button>
                <button
                    class="btn btn-primary"
                    *ngIf="(externaLoanUnits || canAddLine) && addLineOptions.includes('TEMPLATE')"
                    [matMenuTriggerFor]="actionMenu"
                    data-cy="loan-unit-add-template"
                >
                    <i
                        class="fa fa-folder-plus"
                        title="Add template"
                    ></i>
                </button>
            </div>
            <mat-menu #actionMenu="matMenu">
                <button
                    *ngFor="let item of menuItems"
                    mat-menu-item
                    (click)="newAction(item)"
                >
                    {{ item.description }}
                </button>
            </mat-menu>
        </div>
    </div>

    <div class="table-responsive">
            <table
                #loanUnits
                abi-table="LoanUnitsList"
                [columns]="columns"
                [rows]="machinesGroup.getRawValue()"
                class="table-fixed-sm table-sm table-hover m-0"
                [canFilter]="false"
                [hiddenColumns]="true"
                [trackByFunction]="loanUnitsTrackBy"
            >
                <ng-template td="action" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <input
                                *ngIf="
                                    machineGroupAt(i).get('action').enabled &&
                                        !externaLoanUnits;
                                    else actionLbl
                                "
                                formControlName="action"
                                abiTypeahead
                                abiLookup="CodeMachineAction"
                                inputDisplay="code"
                                dropDownDisplay="code"
                                (selectItem)="actionSelected($event.item, machineGroupAt(i))"
                            />
                            <ng-template #actionLbl>
                                <span
                                    class="text-truncate d-block w-99"
                                    >{{
                                        machineGroupAt(i).getRawValue().action
                                    }}
                                </span>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="machine" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <input
                                *ngIf="
                                    machineGroupAt(i).get('machine').enabled;
                                    else machLbl
                                "
                                placement="top-left"
                                abiTypeahead
                                [abiLoanMachine]="
                                    job?.jobId +
                                    '/' +
                                    (codeOnly(machineGroupAt(i).getRawValue().warehouseId) ||
                                        '')
                                "
                                formControlName="machine"
                                placeholder="Select Unit..."
                                [resultTemplate]="loanTemplate"
                                (selectItem)="
                                    machineSelected($event.item, machineGroupAt(i))
                                "
                            />
                            <ng-template #machLbl>
                                <span class="text-truncate d-block w-99">
                                    <abi-tooltip class="" [noTranslate]="true" content="" [tooltip]="machineLabel(machineGroupAt(i), '{modelId} ~ {name}')">{{ machineLabel(machineGroupAt(i)) }}</abi-tooltip>

                                </span>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="ordered" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <input
                                *ngIf="
                                    machineGroupAt(i).get('ordered').enabled;
                                    else qtyLabel
                                "
                                formControlName="ordered"
                                type="number"
                            />
                            <ng-template #qtyLabel>
                                <span class="text-truncate d-block w-99">
                                    {{
                                        machineGroupAt(i).getRawValue().ordered
                                    }}
                                </span>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="warehouseId" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <input
                                *ngIf="machineGroupAt(i).get('warehouseId').enabled; else warehouseLbl"
                                formControlName="warehouseId"
                                abiTypeahead
                                abiLookup="WarehouseMaster"
                                inputDisplay="code"
                                [preFilter]="userWarehouses.bind(this, machineGroupAt(i))"
                                [resultTemplate]="warehouseTemplate"
                                (selectItem)="
                                    warehouseSelected($event.item, machineGroupAt(i))
                                "
                            />
                            <ng-template #warehouseLbl>
                                <span class="text-truncate d-block w-99">
                                    {{
                                        machineGroupAt(i).getRawValue().warehouseId
                                    }}
                                </span>
                            </ng-template>
                            <ng-template
                                #warehouseTemplate
                                let-r="result"
                                let-t="term"
                            >
                                <div class="row" style="min-width: '500px;'">
                                    <ngb-highlight
                                        class="col-10"
                                        [result]="
                                            r.code + ' ~ ' + r.description
                                        "
                                        [term]="t"
                                    ></ngb-highlight>

                                    <ngb-highlight
                                        class="col-2 text-right"
                                        [result]="warehouseStock(machineGroupAt(i), r)"
                                    ></ngb-highlight>
                                </div>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="binId" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <input
                                *ngIf="machineGroupAt(i).get('binId').enabled; else binLbl"
                                formControlName="binId"
                                [preLoad]="!!codeOnly(machineGroupAt(i).getRawValue().warehouseId)"
                                abiTypeahead
                                [abiWarehouseBin]="
                                    codeOnly(machineGroupAt(i).getRawValue().warehouseId) ||
                                    ''"
                                inputDisplay="code"
                                [codeOnly]="true"
                            />
                            <ng-template #binLbl>
                                <span
                                    class="text-truncate d-block w-99"
                                    >{{
                                        codeOnly(machineGroupAt(i).getRawValue().binId)
                                    }}
                                </span>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="serialNumber" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <abi-scan
                                *ngIf="
                                    machineGroupAt(i).get('serialNumber').enabled && !externaLoanUnits;
                                    else serialRo
                                "
                                [count]="1"
                                [checkModel]="false"
                                (scanned)="scanned($event, machineGroupAt(i))"
                                [serialNumber]="machineGroupAt(i).value.serialNumber"
                            >
                                <input
                                    formControlName="serialNumber"
                                    id="serialNumber"
                                />
                            </abi-scan>
                            <ng-template #serialRo>
                                <span
                                    class="text-truncate d-block w-99"
                                    >{{
                                        machineGroupAt(i)?.getRawValue().serialNumber
                                    }}</span
                                >
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template [td]="['field1', 'field2', 'field3', 'field4', 'field5']" let-value="value" let-row="row" let-col="column" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <input
                                *ngIf=" machineGroupAt(i).get(col.field).enabled; else basicLabel"
                                [formControlName]="col.field"
                            />
                            <ng-template #basicLabel>
                                <span
                                    class="text-truncate d-block w-99"
                                    >{{
                                        machineGroupAt(i)?.getRawValue()[col.field]
                                    }}</span
                                >
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="locationId" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <input
                                *ngIf="machineGroupAt(i).get('locationId').enabled; else locationLabel"
                                formControlName="locationId"
                                abiTypeahead
                                abiLookup="CodeMachineLocation"
                                inputDisplay="code"
                            />
                            <ng-template #locationLabel>
                                <span
                                    class="text-truncate d-block w-99"
                                    >{{
                                        machineGroupAt(i)?.getRawValue().locationId
                                    }}</span
                                >
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="requested" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <abi-dateselector
                                formControlName="requested"
                                [disableInput]="false"
                                extraClass="btn-group-sm"
                            ></abi-dateselector>
                            <ng-template #loanRo>
                                <span class="d-inline-block">{{
                                    machineGroupAt(i).getRawValue().requested | date
                                }}</span>
                            </ng-template>
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="deliveryNote" let-value="value" let-row="row" let-i="index">
                    <ng-container [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <a
                                *ngIf="!isPublic"
                                class=""
                                [routerLink]="[
                                    'deliverynote',
                                    machineGroupAt(i).getRawValue().deliveryNote
                                ]"
                                >{{ machineGroupAt(i).getRawValue().deliveryNote }}</a
                            >
                        </ng-container>
                    </ng-container>
                </ng-template>
                <ng-template td="actions" let-value="value" let-row="row" let-i="index">
                    <ng-container  [formGroup]="machinesGroup">
                        <ng-container [formGroupName]="i">
                            <div
                                class="btn-group justify-content-end"
                                *ngIf="userCanEdit"
                            >
                                <button
                                    *ngIf="canDelete(machineGroupAt(i))"
                                    title="Delete entry"
                                    [disabled]="!!machineGroupAt(i).getRawValue()['closed']"
                                    type="button"
                                    class="btn btn-sm btn-primary btn-sm"
                                    (click)="undoMovement(machineGroupAt(i), i)"
                                >
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                                <button
                                    *ngIf="!externaLoanUnits && canCloseLine"
                                    abiToggle
                                    formControlName="closed"
                                    class="btn-sm"
                                    (click)="toggleClosed(machineGroupAt(i))"
                                ></button>
                                <button
                                    *ngIf="canMove(machineGroupAt(i))"
                                    [title]="
                                        loanStages[
                                        machineGroupAt(i).getRawValue().locationId
                                        ]?.label
                                    "
                                    type="button"
                                    class="btn btn-primary btn-sm"
                                    (click)="nextStage(machineGroupAt(i))"
                                >
                                    <i
                                        [class]="
                                            loanStages[
                                            machineGroupAt(i).getRawValue().locationId
                                            ]?.icon
                                        "
                                    ></i>
                                </button>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </table>
    </div>
    <!-- <div class="table-responsive" formArrayName="machines">
        <table
            class="table table-hover table-sm table-fixed"
            style="min-width: 800px"
        >
            <thead class="thead-light">
                <tr>
                    <th style="width: 100px">Action</th>
                    <th class="">Model</th>
                    <th style="width: 80px">Whs</th>
                    <th style="width: 80px">Bin</th>
                    <th class="width: 140px;">Serial</th>
                    <th style="width: 80px">Loc</th>
                    <th style="width: 140px">Request</th>
                    <th style="width: 80px">
                        Del Note
                    </th>
                    <th style="width: 110px" class="text-right">
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-template
                    ngFor
                    let-loan
                    [ngForOf]="machinesGroup.controls"
                    let-i="index"
                >
                    <tr [formGroupName]="i">
                        <td class="align-middle">
                            <input
                                *ngIf="
                                    loan.get('action').enabled &&
                                        !externaLoanUnits;
                                    else actionLbl
                                "
                                formControlName="action"
                                abiTypeahead
                                abiLookup="CodeMachineAction"
                                inputDisplay="code"
                                dropDownDisplay="code"
                                (selectItem)="actionSelected($event.item, loan)"
                            />
                            <ng-template #actionLbl>
                                <span
                                    class="text-truncate d-block w-99"
                                    >{{
                                        loan.getRawValue().action
                                    }}
                                </span>
                            </ng-template>
                        </td>
                        <td class="align-middle">
                            <input
                                *ngIf="
                                    loan.get('machine').enabled;
                                    else machLbl
                                "
                                abiTypeahead
                                [abiLoanMachine]="
                                    job?.jobId +
                                    '/' +
                                    (codeOnly(loan.getRawValue().warehouseId) ||
                                        '')
                                "
                                formControlName="machine"
                                placeholder="Select Unit..."
                                [resultTemplate]="loanTemplate"
                                (selectItem)="
                                    machineSelected($event.item, loan)
                                "
                            />
                            <ng-template #machLbl>
                                <span class="text-truncate d-block w-99">
                                    {{ machineLabel(loan) }}
                                </span>
                            </ng-template>
                        </td>
                        <td class="align-middle">
                            <input
                                *ngIf="loan.enabled; else warehouseLbl"
                                formControlName="warehouseId"
                                abiTypeahead
                                abiLookup="WarehouseMaster"
                                inputDisplay="code"
                                [preFilter]="userWarehouses.bind(this, loan)"
                                [resultTemplate]="warehouseTemplate"
                                (selectItem)="
                                    warehouseSelected($event.item, loan)
                                "
                            />
                            <ng-template #warehouseLbl>
                                <span class="text-truncate d-block w-99">
                                    {{
                                        loan.getRawValue().warehouseId
                                    }}
                                </span>
                            </ng-template>

                            <ng-template
                                #warehouseTemplate
                                let-r="result"
                                let-t="term"
                            >
                                <div class="row" style="min-width: '500px;'">
                                    <ngb-highlight
                                        class="col-10"
                                        [result]="
                                            r.code + ' ~ ' + r.description
                                        "
                                        [term]="t"
                                    ></ngb-highlight>

                                    <ngb-highlight
                                        class="col-2 text-right"
                                        [result]="warehouseStock(loan, r)"
                                    ></ngb-highlight>
                                </div>
                            </ng-template>
                        </td>
                        <td class="align-middle">
                            <input
                                *ngIf="loan.enabled; else binLbl"
                                formControlName="binId"
                                [preLoad]="!!codeOnly(loan.getRawValue().warehouseId)"
                                abiTypeahead
                                [abiWarehouseBin]="
                                    codeOnly(loan.getRawValue().warehouseId) ||
                                    ''"
                                inputDisplay="code"
                                [codeOnly]="true"
                            />
                            <ng-template #binLbl>
                                <span
                                    class="text-truncate d-block w-99"
                                    >{{
                                        codeOnly(loan.getRawValue().binId)
                                    }}
                                </span>
                            </ng-template>
                        </td>
                        <td class="align-middle">
                            <abi-scan
                                *ngIf="
                                    loan.enabled && !externaLoanUnits;
                                    else serialRo
                                "
                                [count]="1"
                                [checkModel]="false"
                                (scanned)="scanned($event, loan)"
                                [serialNumber]="loan.value.serialNumber"
                            >
                                <input
                                    formControlName="serialNumber"
                                    id="serialNumber"
                                />
                            </abi-scan>
                            <ng-template #serialRo>
                                <span
                                    class="text-truncate d-block w-99"
                                    >{{
                                        loan?.getRawValue().serialNumber
                                    }}</span
                                >
                            </ng-template>
                        </td>
                        <td>
                            <input
                                formControlName="locationId"
                                abiTypeahead
                                abiLookup="CodeMachineLocation"
                                inputDisplay="code"
                            />
                        </td>
                        <td>
                            <abi-dateselector
                                formControlName="requested"
                                [disableInput]="false"
                                extraClass="btn-group-sm"
                            ></abi-dateselector>
                            <ng-template #loanRo>
                                <span class="d-inline-block">{{
                                    loan.getRawValue().requested | date
                                }}</span>
                            </ng-template>
                        </td>
                        <td>
                            <a
                                *ngIf="!isPublic"
                                class=""
                                [routerLink]="[
                                    'deliverynote',
                                    loan.getRawValue().deliveryNote
                                ]"
                                >{{ loan.getRawValue().deliveryNote }}</a
                            >
                        </td>
                        <td class="text-right">
                            <div
                                class="btn-group justify-content-end"
                                *ngIf="userCanEdit"
                            >

                                <button
                                    *ngIf="canDelete(loan)"
                                    title="Delete entry"
                                    [disabled]="!!loan.getRawValue()['closed']"
                                    type="button"
                                    class="btn btn-sm btn-primary btn-sm"
                                    (click)="undoMovement(loan, i)"
                                >
                                    <i class="fas fa-trash-alt"></i>
                                </button>
                                <button
                                    *ngIf="!externaLoanUnits && canCloseLine"
                                    abiToggle
                                    formControlName="closed"
                                    class="btn-sm"
                                    (click)="toggleClosed(loan)"
                                ></button>
                                <button
                                    *ngIf="canMove(loan)"
                                    [title]="
                                        loanStages[
                                            loan.getRawValue().locationId
                                        ]?.label
                                    "
                                    type="button"
                                    class="btn btn-primary btn-sm"
                                    (click)="nextStage(loan)"
                                >
                                    <i
                                        [class]="
                                            loanStages[
                                                loan.getRawValue().locationId
                                            ]?.icon
                                        "
                                    ></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </table> -->

        <!-- <pre>{{ machinesGroup.value | json }}</pre> -->
    <!-- </div> -->
</div>

<ng-template #loanTemplate let-r="result" let-t="term">
    <div class="row no-gutters">
        <div class="col-8">
            <span class="text-truncate d-block w-99">
                <ngb-highlight
                    [result]="r.modelId + ' ~ ' + r.name"
                    [term]="t"
                ></ngb-highlight>
            </span>
        </div>

        <div class="col-4">
            <span class="text-truncate text-right d-block w-99">
                <ngb-highlight
                    [result]="r.serialNumber || r.options[4]"
                    [term]="t"
                ></ngb-highlight>
                <!--  || r.fields[4] -->
            </span>
        </div>
    </div>
</ng-template>
